var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"block placeholder"},[_c('div',{staticClass:"block__content"},[_c('span',{staticClass:"block__name"},[_c('b-skeleton',{attrs:{"width":"35%","height":"20"}}),_c('b-skeleton',{attrs:{"width":"60%","height":"10"}})],1),_c('span',{staticClass:"block__copy"},[_c('b-skeleton',{attrs:{"width":"150","height":"25"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }